import { app } from '@/main'
import { getStorage, setStorage } from '@GUTIL/other'

const cacheLang = getStorage('lang')
const langMap = {
  'zh-TW': 'zh-TW',
  'zh-CN': 'zh-CN'
}

const state = {
  lang:
    cacheLang ||
    // langMap[navigator.language] ||
    // langMap[navigator.userLanguage] ||
    'zh-CN'
}

const actions = {
  async [_GM.CHANGE_LANG]({ commit }, params) {
    let lang = params
    // 繁簡皆不符合, 預設簡中
    if (!langMap[lang]) {
      lang = 'zh-CN'
    }
    lang && commit('CHANGE_LANG', lang)
    setStorage('lang', lang)
  }
}

const mutations = {
  [_GM.CHANGE_LANG](state, payload) {
    app.$i18n.locale = payload
    state.lang = payload
  }
}

const getters = {
  lang: state => state.lang
}

export default {
  state,
  getters,
  actions,
  mutations
}
